export default __webpack_public_path__ + "static/media/project2.d7e49946.png";